import Vue from "vue"
import VueRouter from 'vue-router' 
Vue.use(VueRouter)

//解决连续多次点击跳转报错
const originalPush = VueRouter.prototype.push
VueRouter.prototype.push = function push(location) {
  return originalPush.call(this, location).catch(err => err)
}

export default new VueRouter({
	mode: 'history',
    routes:[
      {
          path: '/',
          name: 'home',
          component: ()=>import('../views/home'),
        },
        {
          path: '/',
          name: 'home',
          component: ()=>import('../views/home'),
        },
        {
          path: '/company',
          name: 'company',
          component: ()=>import('../views/company'),
        },
        {
          path: '/yewu',
          name: 'yewu',
          component: ()=>import('../views/yewu'),
        },
        {
          path: '/news',
          name: 'news',
          component: ()=>import('../views/news'),
        },
        {
          path: '/newsDtl',
          name: 'newsDtl',
          component: ()=>import('../views/newsDtl'),
        },
        {
          path: '/contact',
          name: 'contact',
          component: ()=>import('../views/contact'),
        },
        {
          path: '/search',
          name: 'search',
          component: ()=>import('../views/search'),
        },

    ]
})


